module.exports = __webpack_public_path__ + "img/float-btn-slot.e5f48da3.svg";